.track {
	position: fixed;
	inset-block-start: 0;
	inset-inline: 0;
	z-index: calc(var(--z-overlay) + 1);
	block-size: 2px;
	pointer-events: none;

	.bar {
		block-size: 100%;
		background-color: var(--colour-brand-primary);
		border-start-end-radius: var(--radius-full);
		border-end-end-radius: var(--radius-full);
		box-shadow: 0 0 8px var(--colour-brand-primary);
		transition: width 0.2s ease;

		&[data-done] {
			opacity: 0;
			transition:
				width 0.2s ease,
				opacity 0.2s ease 0.1s;
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.bar {
			transition: none;
		}
	}
}
